import { render, staticRenderFns } from "./TablaComponente.vue?vue&type=template&id=660a17e6&scoped=true"
import script from "./TablaComponente.vue?vue&type=script&lang=js"
export * from "./TablaComponente.vue?vue&type=script&lang=js"
import style0 from "./TablaComponente.vue?vue&type=style&index=0&id=660a17e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660a17e6",
  null
  
)

export default component.exports